export default __webpack_public_path__ + "media/icon_2.c49652bc.svg";